import axios from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';
import { useTechnicianSessionStore } from '../store/technicianSession';
import { getRuntimeConfig } from '../config/runtimeConfig';

const resolveBaseUrl = () => `${getRuntimeConfig().apiBaseUrl.replace(/\/$/, '')}/`;

const api = axios.create({
  baseURL: resolveBaseUrl(),
  timeout: 10000
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.baseURL = resolveBaseUrl();

  const token = useTechnicianSessionStore.getState().token;

  if (token) {
    const headers = config.headers;

    if (headers && typeof (headers as any).set === 'function') {
      (headers as any).set('Authorization', `Bearer ${token}`);
    } else {
      config.headers = {
        ...(headers ?? {}),
        Authorization: `Bearer ${token}`
      } as any;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url ?? '';

    if (status === 401 && !(requestUrl?.includes('/login'))) {
      void useTechnicianSessionStore.getState().clearSession('Sitzung abgelaufen. Bitte erneut anmelden.');
    }

    return Promise.reject(error);
  }
);

export default api;
